import TranslationPresentation, { ITranslationPresentationProps } from "../presentations/TranslationPresentation";
import { getTranslations } from "../reducers/translations";
import { IState } from "../store/state";
import { connect } from "react-redux";

export interface ITranslationContainerProps {
    tag: string
}

const mapStateTopProps = (state:IState, ownProps: ITranslationContainerProps ) : ITranslationPresentationProps => ({
    translations: getTranslations(state),
    tag: ownProps.tag,
});
  
export default connect(mapStateTopProps)(TranslationPresentation);
